module.exports = __webpack_public_path__ + "img/step4.a85900e4.svg";